import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/project-granularities'

interface Endpoints {
  getAll: NoParamEndpointConstructor
}

export const granularitiesEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
}
